<template>
    <v-container fluid>
        <v-row v-if="!loading.doctor && filteredDoctors.length > 0">
            <div style="display: block; width: 100%;" class="text-right">
                <span class="float-left" style="padding-left: 15px;">
                    Items per page: <v-select
                        v-model="itemsPerPage"
                        :items="itemsPerPageOptions"
                        style="width: 100px; display: inline-block;"
                        dense
                        outlined
                        color="success"
                        hide-details
                        class="healthcareDoctorClass"
                    />
                </span>
                <span v-if="itemsInPage > 0" class="float-right" style="height: 40px; padding: 10px 15px 0 0; ">
                    Showing: {{ currentRow }} - {{ currentRow + itemsInPage - 1 }} of {{ filteredDoctors.length }}
                </span>
                <span v-else class="float-right" style="height: 40px;">
                    No results to show.
                </span>
                <v-pagination
                    v-model="page"
                    :length="pageCount"
                    circle
                    color="success"
                    style="display: block; text-align: center;"
                    total-visible="7"
                />
            </div>
            <v-col
                v-for="doc in paginatedDoctors"
                :key="doc.doc_id"
                cols="12"
                sm="6"
                md="4"
                class="d-flex"
            >
                <v-card 
                    class="hosp-item-doctor-partner d-flex flex-column pa-4 w-100" 
                    @click="displayDoctorsFromCity(doc)"
                >
                    <h3 class="text-h6 font-weight-bold mb-3">
                        {{ doc.doc_name }}
                    </h3>

                    <!-- Specialization -->
                    <div v-if="specDesc(doc)" class="d-flex align-start mb-2">
                        <v-icon class="mr-2">
                            {{ mdiStethoscope }}
                        </v-icon>
                        <span>{{ specDesc(doc) }}</span>
                    </div>

                    <!-- Location Footer -->
                    <div class="mt-auto pt-2">
                        <div v-for="a in visibleCities(doc)" :key="`${a.city_name}|${a.city_province}`" class="d-flex align-center mb-1">
                            <v-icon class="mr-2">
                                {{ mdiHospitalMarker }}
                            </v-icon>
                            <span>
                                {{ a.city_name }}, {{ a.city_province }} · {{ a.city_region }}
                                <span v-if="a.count > 1">({{ a.count }} facilities)</span>
                            </span>
                        </div>
                        <div
                            v-if="uniqueCities(doc).length > 3"
                            class="text-caption mb-1"
                            style="padding-left: 32px; color: #4EB352; cursor: pointer; font-weight: 700;"
                            @mousedown.stop.prevent
                            @touchstart.stop
                            @click.stop="toggleExpand(doc.doc_id)"
                        >
                            {{ expandedDocs[doc.doc_id] ? 'Show less' : `+${uniqueCities(doc).length - 3} more` }}
                        </div>
                    </div>
                </v-card>
            </v-col>
            <div style="display: block; width: 100%;" class="text-right">
                <span class="float-left" style="padding-left: 15px;">
                    Items per page: <v-select
                        v-model="itemsPerPage"
                        :items="itemsPerPageOptions"
                        style="width: 100px; display: inline-block;"
                        dense
                        outlined
                        color="success"
                        hide-details
                        class="healthcareDoctorClass"
                    />
                </span>
                <span v-if="itemsInPage > 0" class="float-right" style="height: 40px; padding: 10px 15px 0 0; ">
                    Showing: {{ currentRow }} - {{ currentRow + itemsInPage - 1 }} of {{ filteredDoctors.length }}
                </span>
                <span v-else class="float-right" style="height: 40px;">
                    No results to show.
                </span>
                <v-pagination
                    v-model="page"
                    :length="pageCount"
                    circle
                    color="success"
                    style="display: block; text-align: center;"
                    total-visible="7"
                />
            </div>
        </v-row>
        <v-row v-else-if="!loading.doctor" style="padding: 25px;">
            <v-col class="text-center" style="border-radius: 12px; border: 2px dashed #4EB352;">
                <v-icon style="font-size: 100px;" color="success">
                    {{ mdiAccountSearchOutline }}
                </v-icon>
                <h1 style="margin: 30px 0; color: #4CAF50; font-size: 23px;">
                    No Doctors Found
                </h1>
                <p>We couldn't find any doctors matching your search criteria. Try adjusting your filters.</p>
            </v-col>
        </v-row>
        <v-row v-else style="height: 50px;">
            <v-progress-linear
                color="success"
                reverse
                height="25"
                indeterminate
            />
        </v-row>
        <v-btn
            v-if="showGoToTop"
            color="success"
            fab
            large
            style="position: fixed; bottom: 18px; right: 10%; z-index: 20;"
            @click="handleGoToTop"
        >
            <v-icon>{{ mdiMenuUp }}</v-icon>
        </v-btn>
        <DoctorsTableDialog
            :show="showHospitalDialog"
            :doctor="doctor"
            :loading="loading"
            @closeDialog="showHospitalDialog=false"
        />
    </v-container>
</template>

<script>
import { mdiAccountSearchOutline, mdiHospitalMarker, mdiMapMarkerRadius, mdiMenuUp, mdiStethoscope } from '@mdi/js'
import DoctorsTableDialog from '../dialog_tables/DoctorsTable_dialog.vue'
import { mapActions, mapGetters } from 'vuex'
export default {
    components: {
        DoctorsTableDialog
    },
    props: ['loading', 'search'],
    data() {
        return {
            expandedDocs: {},
            mdiAccountSearchOutline, mdiHospitalMarker, mdiMapMarkerRadius, mdiMenuUp, mdiStethoscope,
            showGoToTop: false,
            goToOptions: {
                duration: 500,
                offset: 700,
                easing: 'easeInOutCubic'
            },
            page: 1,
            itemsPerPage: 10,
            itemsPerPageOptions: [5, 10, 20, 30, 40, 50, 100, 200, 300, 400, 500],
            showHospitalDialog: false,
            doctor: null,
            headers: [
                { text: 'Doctors', value: 'doc_name', sortable: true },
                { text: 'Specialization', value: 'sp_desc', sortable: true },
                { text: 'City', value: 'city_name', sortable: true },
                { text: 'Province', value: 'city_province', sortable: true },
                { text: 'Region', value: 'city_region', sortable: true }
            ]
        }
    },
    computed: {
        ...mapGetters(['getRegions', 'getProvinces', 'getCities', 'getSpecializations', 'getDoctors', 'getDoctorDialog']),
        groupedDoctors() {
            const map = new Map()
            for (const row of this.getDoctors) {
                let group = map.get(row.doc_id)
                if (!group) {
                    group = {
                        doc_id: row.doc_id,
                        doc_name: row.doc_name,
                        sp_desc: this.wrapSpecializations(row),
                        locations: [],
                        regions: []
                    }
                    map.set(row.doc_id, group)
                }
                if (row.city_name) {
                    const key = `${row.city_name}|${row.city_province}`
                    if (!group.locations.some(l => l.key === key)) {
                        group.locations.push({ key, city_name: row.city_name, city_province: row.city_province })
                    }
                }
                if (row.city_region && !group.regions.includes(row.city_region)) {
                    group.regions.push(row.city_region)
                }
            }
            return [...map.values()]
        },
        filteredDoctors() {
            const keyword = ((this.search && this.search.value) || '').toLowerCase()
            const list = this.getDoctors || []
            if (!keyword) return list
            return list.filter(d => (d.doc_name || '').toLowerCase().includes(keyword))
        },
        paginatedDoctors() {
            if (this.itemsPerPage === -1) return this.filteredDoctors
            const start = (this.page - 1) * this.itemsPerPage
            return this.filteredDoctors.slice(start, start + this.itemsPerPage)
        },
        itemsInPage() {
            return this.paginatedDoctors.length
        },
        currentRow() {
            if (this.itemsPerPage === -1) return 1
            return (this.page - 1) * this.itemsPerPage + 1
        },
        pageCount() {
            if (this.itemsPerPage === -1) return 1
            return Math.max(1, Math.ceil(this.filteredDoctors.length / this.itemsPerPage))
        }
    },
    watch: {
        getDoctorDialog() {
            this.loading.doctor = false
        },
        getDoctors() {
            this.loading.doctor = false
            this.page = 1
            this.expandedDocs = {}
        },
        itemsPerPage() {
            this.page = 1
        },
        'search.value'() {
            this.page = 1
        },
        pageCount(newCount) {
            if (this.page > newCount) this.page = newCount
        }
    },
    mounted() {
        window.addEventListener('scroll', this.checkScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.checkScroll)
    },
    methods: {
        ...mapActions(['doctorsDialog']),
        uniqueCities(doc) {
            const seen = {}
            for (const a of doc.affiliates || []) {
                const key = `${a.city_name}|${a.city_province}`
                if (!seen[key]) seen[key] = { ...a, count: 0 }
                seen[key].count++
            }
            return Object.values(seen)
        },
        visibleCities(doc) {
            const seen = {}
            for (const a of doc.affiliates || []) {
                const key = `${a.city_name}|${a.city_province}`
                if (!seen[key]) seen[key] = { ...a, count: 0 }
                seen[key].count++
            }
            const list = Object.values(seen)
            return this.expandedDocs[doc.doc_id] ? list : list.slice(0, 3)
        },
        toggleExpand(docId) {
            this.$set(this.expandedDocs, docId, !this.expandedDocs[docId])
        },
        visibleAffiliates(doc) {
            const list = doc.affiliates || []
            return this.expandedDocs[doc.doc_id] ? list : list.slice(0, 3)
        },
        specDesc(d) {
            if (!d) return ''
            return [d.doc_specialization_1, d.doc_specialization_2, d.doc_specialization_3]
                .map(s => (s == null ? '' : String(s).trim()))
                .filter(Boolean)
                .join(' - ')
        },
        checkScroll() {
            this.showGoToTop = window.scrollY > 1000 // adjust threshold as needed
        },
        handleGoToTop() {
            let el = document.querySelector('.healthcareDoctorClass')
            if (el) this.$vuetify.goTo(el, this.goToOptions)
        },
        displayDoctorsFromCity(doc) {
            this.doctor = doc
            this.showHospitalDialog = true
        },
        wrapSpecializations({ doc_specialization_1, doc_specialization_2, doc_specialization_3 }) {
            return [doc_specialization_1, doc_specialization_2, doc_specialization_3]
                .map(s => (s == null ? '' : String(s).trim()))
                .filter(Boolean)
                .join(' - ')
        }
    }
}
</script>

<style>
.hosp-item-doctor-partner h3 {
  margin-bottom: 16px !important;
  color: #1f2937;
  line-height: 1.3;
  font-size: 23px;
  font-weight: 700;
}
.hosp-item-doctor-partner {
  padding: 24px !important;
  margin-bottom: 16px;
  min-height: 220px;
  width: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  border: 2px solid transparent;
}
  .hosp-item-doctor-partner .v-chip {
    font-weight: 600 !important; /* Less bold */
    font-size: 12px !important;
    margin-top: 16px;
    align-self: flex-start; /* Better alignment */
  }
.hosp-item-doctor-partner:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(78, 179, 82, 0.15);
  border-color: #4EB352;
}
  .hosp-item-doctor-partner ul {
    display: grid;
    gap: 12px;
    margin-bottom: 8px;
  }
    .hosp-item-doctor-partner ul li {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      width: 100%;
    }
      .hosp-item-doctor-partner ul li i {
        color: #4EB352 !important;
        font-size: 18px !important;
        margin-top: 2px;
        flex-shrink: 0;
      }
        .hosp-item-doctor-partner ul li span {
          flex: 1;
          font-size: 14px;
          color: #6b7280;
          line-height: 1.4;
        }
</style>
